import { createContext } from 'react'

/** The linking/config scope a tutorial's live preview renders in, apart from every real page. */
export const TUTORIAL_PREVIEW_PAGE_ID = 'tutorial-preview'

/**
 * True inside a tutorial's live preview: a real widget rendered look-only in the tutorial
 * dialog. `useCapabilities` allows everything there (a Pro widget previews as the real thing,
 * not its lock screen) and `useWidgetConfigSync` writes nothing (the preview card isn't on any
 * page).
 */
export const TutorialPreviewContext = createContext(false)
